import { render } from "./GroupIntroduction.vue?vue&type=template&id=5e3322dc&scoped=true"
import script from "./GroupIntroduction.vue?vue&type=script&lang=js"
export * from "./GroupIntroduction.vue?vue&type=script&lang=js"

import "./GroupIntroduction.vue?vue&type=style&index=0&id=5e3322dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3322dc"]])

export default __exports__